module.exports = __webpack_public_path__ + "img/about-icon-03.ed883265.svg";